<template>
  <div class="remove-layout-v3">
    <RemoveUploader />
    <RemoveResult />
  </div>

  <div v-if="workbench.lightbox.show" class="lightbox" @click="workbench.closeLightbox">
    <img :src="workbench.lightbox.url" alt="preview" @click.stop />
    <button class="lightbox-close" @click.stop="workbench.closeLightbox">×</button>
  </div>
</template>

<script setup>
import RemoveUploader from '@/components/remove/RemoveUploader.vue'
import RemoveResult from '@/components/remove/RemoveResult.vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'

const workbench = useWorkbenchStore()
</script>
